export const setUserAction = user => ( {
	type: 'SETUSER',
	payload: user
} )

export const another = true